import { useContext, useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { MyContext } from '../../context';
import DataTable from '../../components/tables/DataTable';
import Pagination from '../../components/Pagination';
import { listProductErpMappings } from '../../utils/queries';

const PAGE_SIZE = 20;

export default function ProductErpMappings() {
	const { activeStoreId } = useContext(MyContext);
	const [mappings, setMappings] = useState([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const [search, setSearch] = useState('');
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!activeStoreId) return;
		setLoading(true);
		listProductErpMappings({
			storeId: activeStoreId,
			limit: PAGE_SIZE,
			offset: page * PAGE_SIZE,
			search: search || undefined,
		}).then((result) => {
			if (result?.success) {
				setMappings(result.data.product_erp_mappings);
				setTotal(result.data.pagination.total);
			}
			setLoading(false);
		});
	}, [activeStoreId, page, search]);

	const columns = [
		{ key: 'externalProductId', header: 'External Product ID' },
		{ key: 'externalVariantId', header: 'External Variant ID' },
		{ key: 'sku', header: 'SKU' },
		{ key: 'erpInventoryItemId', header: 'ERP Inventory Item ID' },
		{ key: 'erpUom', header: 'ERP UOM' },
	];

	return (
		<div className='py-8 pr-8'>
			<h1 className='text-2xl font-light tracking-tight mb-2'>Shopify Mappings</h1>
			<p className='text-sm text-gray-500 mb-6'>
				Read-only - maps Shopify product/variant identifiers to ERP ERP inventory items for troubleshooting.
			</p>

			<div className='mb-5'>
				<label>Search (SKU, ERP inventory item ID)</label>
				<div className='relative max-w-sm'>
					<Search className='pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 size-4 text-gray-400' />
					<input
						className='w-52 form-input pl-9'
						value={search}
						onChange={(e) => {
							setSearch(e.target.value);
							setPage(0);
						}}
					/>
				</div>
			</div>

			<DataTable columns={columns} data={mappings} loading={loading} emptyHeading='No ERP mappings found' />
			<Pagination pageCount={Math.ceil(total / PAGE_SIZE)} currentPage={page} onPageChange={setPage} />
		</div>
	);
}
